const NodeIdentity = () => {
  return <h1>Node Identity</h1>
}

export default NodeIdentity
